import { Directive, HostListener, ElementRef, Input } from "@angular/core";

@Directive({
    selector: "[appDecimalNumber]",
})
export class AppDecimalNumbersDirective {
    @Input() length: string;

    constructor(private _el: ElementRef) {}

    @HostListener("keypress", ["$event"]) onKeyPress(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            !(charCode == 46 || charCode == 8)
        )
            return false;
        else {
            var len = this._el.nativeElement.value.length;
            var index = this._el.nativeElement.value.indexOf(".");
            if (index > 0 && charCode == 46) {
                return false;
            }
            if (index > 0) {
                var CharAfterdot = len - index;
                if (CharAfterdot > Number(this.length)) {
                    return false;
                }
            }
        }
        return true;
    }
}
